import { ICreateAndUpdateFinancialGroup } from "../../../types/financialGroup";
import customAxios from "../../customAxios";
import { UPDATE_FINANCIAL_GROUP, UPDATE_SUPER_AGENT } from "../../routes";

const updateFinancialGroup = async (
  formData: ICreateAndUpdateFinancialGroup,
  _id: string
) => {
  console.log(formData);
  try {
    return (
      await customAxios.put(UPDATE_FINANCIAL_GROUP + `/${_id}`, {
        ...formData,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_SUPER_AGENT: error });
    return false;
  }
};

export default updateFinancialGroup;
